// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DrugShipForm__wrapper__3br6r","submitResult":"DrugShipForm__submitResult__J3haq","actionWrapper":"DrugShipForm__actionWrapper__Grv9P","wrapper2faOptions":"DrugShipForm__wrapper2faOptions__3uq6K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DrugShipForm/DrugShipForm.css
// module id = 3028
// module chunks = 0